/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Settings_LabelInputs */

const en_welcome_settings_label = /** @type {(inputs: Welcome_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferences`)
};

const fr_welcome_settings_label = /** @type {(inputs: Welcome_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préférences`)
};

const ms_sg2_welcome_settings_label = /** @type {(inputs: Welcome_Settings_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilihan`)
};

/**
* | output |
* | --- |
* | "Preferences" |
*
* @param {Welcome_Settings_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_settings_label = /** @type {((inputs?: Welcome_Settings_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Settings_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_settings_label(inputs)
	if (locale === "fr") return fr_welcome_settings_label(inputs)
	return ms_sg2_welcome_settings_label(inputs)
});